/* eslint-disable no-underscore-dangle */
/**
 * useDistances Application Logic Hook
 * Define distances from coordenate reference filtering by maxDistance and sort by distance
 *
 * References:
 *  - https://github.com/stefanocudini/leaflet-list-markers
 *
 * Possible updates:
 */
import { useMemo, useState } from 'react';

import { calculateDistanceByCoords } from '../support/services/geolocalization';

export default function useDistances() {
  const [addresses, setAddresses] = useState(null);
  const [referenceCoords, setReferenceCoords] = useState(null);
  const [maxDistance, setMaxDistance] = useState(null);

  /**
    * Sort location (aka. addresses) by distance from current user location
    * @param {*} addresses addresses to sort
    * @param {*} options
    * @returns sorted addresses
    */
  const addressesSortedByDistance = useMemo(() => {
    if (!addresses) return [];

    const addressesWithDistances = addresses.map((address) => ({
      ...address,
      distance: calculateDistanceByCoords(address.lat, address.lng, referenceCoords.lat, referenceCoords.lng),
    }));

    const addressesToSort = maxDistance
      ? addressesWithDistances.filter((address) => address.distance <= maxDistance)
      : addressesWithDistances;

    return addressesToSort.sort((a, b) => {
      if (a.distance < b.distance) return -1;
      if (a.distance > b.distance) return 1;
      return 0;
    });
  }, [addresses, referenceCoords, maxDistance]);

  return {
    sharedStates: {
      addresses,
      addressesSortedByDistance,
    },
    commands: {
      setAddresses,
      setReferenceCoords,
      setMaxDistance,
    },
  };
}
